import { Link } from "react-router-dom";

function Logo() {
  return (
    <Link className="navbrand" to="/">
      Holidaze
    </Link>
  );
}

export default Logo;
